import { Resource } from '../../../enums/Resource';
import { Role } from '../../../enums/Role';
import { getAddNewItemPermission } from './resources/addNewItem';
import { getAdministrationPermission } from './resources/administration';
import { getAppPermission } from './resources/app';
import { getBacktagWidgetPermission } from './resources/backtagWidget';
import { getCommentWidgetPermission } from './resources/commentWidget';
import { getEFSEditPermission } from './resources/efs';
import { getItemActionsMenuPermission } from './resources/itemActionsMenu';
import { getPushPermission } from './resources/push';
import { getRemoveItemPermission } from './resources/removeItem';
import { updateAudiencesPermission } from './resources/updateAudiences';
import { getViewAdministrationPermission } from './resources/viewAdministration';
import { GetPermissionFn, GetPermissionPayload, Permission } from './types';

const workspaceOwnerAccess: GetPermissionFn = ({
  isWorkspaceOwner,
  hasRole
}) => {
  if (!hasRole(Role.planningReadonly) && isWorkspaceOwner) {
    return { canView: true, canEdit: true };
  }
  return { canView: true, canEdit: false };
};

const ResourcePermissions: {
  [x in Resource]: GetPermissionFn;
} = {
  [Resource.app]: getAppPermission,
  [Resource.schema]: workspaceOwnerAccess,
  [Resource.view]: workspaceOwnerAccess,
  [Resource.administration]: getAdministrationPermission,
  [Resource.viewAdministration]: getViewAdministrationPermission,
  [Resource.push]: getPushPermission,
  [Resource.addNewItem]: getAddNewItemPermission,
  [Resource.commentWidget]: getCommentWidgetPermission,
  [Resource.backtagWidget]: getBacktagWidgetPermission,
  [Resource.efsEdit]: getEFSEditPermission,
  [Resource.itemActionsMenu]: getItemActionsMenuPermission,
  [Resource.updateAudiences]: updateAudiencesPermission,
  [Resource.removeItem]: getRemoveItemPermission
};

const getResource = ({ resource }: GetPermissionPayload) => {
  return resource;
};

export const getResourcePermission: GetPermissionFn = (p): Permission => {
  const resource = getResource(p);
  if (!resource) return { canView: false, canEdit: false };
  const getPermission = ResourcePermissions[resource];
  if (getPermission == null) {
    console.warn('Permission fn not defined for resource: ' + resource);
    return { canView: false, canEdit: false };
  }
  return getPermission(p);
};
